(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("laxar"));
	else if(typeof define === 'function' && define.amd)
		define(["laxar"], factory);
	else if(typeof exports === 'object')
		exports["laxar-mocks"] = factory(require("laxar"));
	else
		root["laxar-mocks"] = factory(root["laxar"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition